import { island } from './island-validations'

export const validations = {
	island
}
